const nameSpace = 'pointGroupCatalog'

export const mutations = {
  SET_POINT_GROUP_LIST: `${nameSpace}/SET_POINT_GROUP_LIST`,
  REMOVE_POINT_GROUP_LIST: `${nameSpace}/REMOVE_POINT_GROUP`,
  RESET_POINT_GROUP_LIST: `${nameSpace}/RESET_POINT_GROUP_LIST`,
  SET_SELECTED_POINT_GROUP: `${nameSpace}/SET_SELECTED_POINT_GROUP`,
  SET_SELECTED_ALL_POINT_GROUP: `${nameSpace}/SET_SELECTED_ALL_POINT_GROUP`,
  SET_ALERT_MODAL_IS_SHOW: `${nameSpace}/SET_ALERT_MODAL_IS_SHOW`,
}

export const actions = {
  SET_POINT_GROUP_LIST: `${nameSpace}/SET_POINT_GROUP_LIST`,
  REMOVE_POINT_GROUP_LIST: `${nameSpace}/REMOVE_POINT_GROUP_LIST`,
  RESET_POINT_GROUP_LIST: `${nameSpace}/RESET_POINT_GROUP_LIST`,
  SET_SELECTED_POINT_GROUP: `${nameSpace}/SET_SELECTED_POINT_GROUP`,
  SET_SELECTED_ALL_POINT_GROUP: `${nameSpace}/SET_SELECTED_ALL_POINT_GROUP`,
  SET_ALERT_MODAL_IS_SHOW: `${nameSpace}/SET_ALERT_MODAL_IS_SHOW`,
}

export const getters = {
  pointGroupListByOwnerProfileId: `${nameSpace}/pointGroupListByOwnerProfileId`,
  alertModalIsShow: `${nameSpace}/alertModalIsShow`,
}
